import React, { useState, useEffect, useCallback } from "react";
import { Select, Button, Divider, Spin, Form, Input, Modal, message, Row, Col, Upload } from 'antd';
import { EyeOutlined, PlusOutlined, FormOutlined, UploadOutlined } from "@ant-design/icons";
import { Redirect } from 'react-router';
import { getTiposDocumentacionAdjudicacion, getArticulosAdjudicacion, enviaNotificacionAdjudicacion, 
        desactivaAdjudicacion, procesaCargaMasiva, 
        procesaCargaMasivaAdjudicacion} from "../../api/adjudicacion";
import { Tooltip } from '@material-ui/core';
import Table from "react-table-v6";
import Paginacion from "../ListaDocs/Paginacion";
import GridFilters from "../../utils/GridFilters";
import useAuth from "../../hooks/useAuth";
import "./ConsultarArticulosAdjudicaciones.scss";
import Mensajes from "../Mensajes/Mensajes";
import logoAyuda from "../../assets/img/noAdjudicar.svg";

const { Option } = Select;
const { TextArea } = Input;

export default function ConsultarArticulosAdjudicaciones(props) {
    var tiempoMensaje = 5;
    
    const { user } = useAuth();

    const { getFieldDecorator } = props.form;

    const permisos = localStorage.getItem('ROL_USUARIO');

    const [loading, setLoading] = useState(false);

    const [options, setOptions] = useState({
        data: [],
        loadingData: false
    });

    const [selected, setSelected] = useState({
        data: props.idTipoDocumentacion === null || props.idTipoDocumentacion === undefined ? -1 : props.idTipoDocumentacion
    });

    const [articulosData, setArticulosData] = useState({
        data: [],
        notificacionDisable: true,
        loadingData: false
    });

    const [acciones, setAcciones] = useState({
        enableCaptura: false,
        enableModificar: false
    });

    const [visibleAlert, setVisibleAlert] = useState({
        activado: false,
        tipoMensaje: "",
        mensaje: ""
    });

    const [redirect, setRedirect] = useState({
        redirecting: false,
        url: "",
        idArticulo: -1,
        idTipoDocumentacion: -1,
        nombreArticulo: "",
    });

    const [eliminar, setEliminar] = useState({
        visible: false,
        idArticulo: -1,
        idTipoDocumentacion: -1,
        nombre:""
    });

    const [muestraJustificacion, setMuestraJustificacion] = useState({
        visible: false,
        nombreArticulo: "",
        justificacion: "",
    });

    const [archivoCargaMasiva,     setArchivoCargaMasiva]     = useState({
        uploading: false,
        file: "",
        urlPDF: null,
        mostrarModal: false,
    });

    const [fileList,setFileList] = useState([]);

    const propsCargaMasiva = {
        multiple: false,
        fileList: fileList,
        onChange: file =>{
            if (file.fileList.length > 1) {
                setFileList([file.fileList[file.fileList.length - 1]]);
            } else {
                setFileList(file.fileList);
            }
        },
        onRemove: file => {
            setArchivoCargaMasiva(archivoDisenioU => {
                return {
                    file: archivoDisenioU.file
                };
            });
        },
        beforeUpload: file => {
            let isCSV = file.type === 'application/vnd.ms-excel';
            isCSV = isCSV | file.type === 'text/csv';
            const isSomething = file.size > 0;
            const isSize = (file.size / 1024 / 1024) < 50;
            if (!isCSV) {
               message.error("El formato del archivo no corresponde a un CSV. Favor de borrarlo y cargar uno válido.",tiempoMensaje);
                return true;
            }
            if (!isSomething) {
                message.error("El archivo se encuentra vacío. Favor de borrarlo y cargar uno válido.",tiempoMensaje);
                return true;
            }
            if (!isSize) {
                message.error("El archivo pesa más de 50 MB. Favor de borrarlo y cargar uno válido.",tiempoMensaje);
                return false;
            }
            if (isCSV && isSomething && isSize) {
                setArchivoCargaMasiva({
                    file:  file,
                    uploading: archivoCargaMasiva.uploading,
                    mostrarModal:true
                });
                
            }
            return false;
        },
        archivoCargaMasiva
    };

    const handleSelect = useCallback((value) => {
       // console.log("TipoDocumentacion:=>", value);
        setSelected({
            data: value
        });
        setArticulosData({
            data: [],
            notificacionDisable: true,
            loadingData: false
        });
        doRequestArticulos(value);
    });

    const handleNotificar = useCallback(() => {
        doRequestNotificacion();
    });

    const handleClickRegistrar = useCallback((id, nombre, conAlerta) => {
        //console.log("Handle registrar adjudicación");
        setRedirect({
            redirecting: true,
            url: '/adjudicacion/registrarAdjudicaciones',
            idArticulo: id,
            idTipoDocumentacion: selected.data,
            nombreArticulo: nombre,
        })
    });

    const handleClickConsultar = useCallback((id, nombre, conAlerta, justificacion) => {
        //console.log("Handle consultar adjudicación");
        if (conAlerta) {
            setMuestraJustificacion({
                visible: true,
                nombreArticulo: nombre,
                justificacion: justificacion,
            });
        }
        else {
            setRedirect({
                redirecting: true,
                url: '/adjudicacion/consultarAdjudicaciones',
                idArticulo: id,
                idTipoDocumentacion: selected.data,
                nombreArticulo: nombre,
            })
        }
    });

    const handleClickModificar = useCallback((id, nombre, conAlerta) => {
        setRedirect({
            redirecting: true,
            url: '/adjudicacion/modificarAdjudicaciones',
            idArticulo: id,
            idTipoDocumentacion: selected.data,
            nombreArticulo: nombre,
        })
    });

    const handleClickEliminar = useCallback((id, nombre, conAlerta) => {
        setEliminar({
            visible: true,
            idArticulo: id,
            idTipoDocumentacion: selected.data,
            nombre:nombre
        });
    });

    //Se definen las columnas de la tabla de Correos electrónicos
    const columns = [
        {
            Header: "No.",
            accessor: "consecutivo",
            style: {
                textAlign: "left"
            },
            width: 75,
            maxWidth: 75,
            minWidth: 75,
            filterable: false,
            sortable: true,
            style: {
                textAlign: "center"
            },
        },
        {
            Header: "Documento/Material",
            accessor: "nombre",
            sortable: true,
            ...GridFilters
        },
        {
            Header: "Tipo de elección",
            accessor: "nombreTipoEleccion",
            sortable: true,
            ...GridFilters
        },
        {
            Header: "Acciones",
            style: {
                color: "blue"
            },
            width: 125,
            maxWidth: 125,
            minWidth: 125,
            Cell: props => {
                return (
                  //  console.log("Se pintan las celdas"),
                    <div className="div-acciones">
                        {props.original.acciones.map((value, index) => {
                            //console.log("value.nombre", value.nombre);
                            if (value.nombre === "consultar") {
                                return [
                                    <Tooltip title="Consultar">
                                        <Button
                                            className="ilist"
                                            type="link"
                                            shape="circle"
                                            onClick={handleClickConsultar.bind(
                                                this,
                                                props.original.id,
                                                props.original.nombre,
                                                value.conAlerta,
                                                props.original.justificacion,
                                            )}
                                            disabled={!value.isActivo}
                                        >
                                            <EyeOutlined />
                                        </Button>
                                    </Tooltip>,
                                    <Divider className="dcolor" type="vertical" />
                                ];
                            } else if (value.nombre === "agregar") {
                                return (
                                    <Tooltip title="Adjudicar">
                                        <Button
                                            className="ilist"
                                            type="primary"
                                            shape="circle"
                                            accept=""
                                            onClick={handleClickRegistrar.bind(
                                                this,
                                                props.original.id,
                                                props.original.nombre,
                                                props.original.conAlerta)}
                                            disabled={!value.isActivo || !acciones.enableCaptura}
                                        >
                                            <PlusOutlined />
                                        </Button>
                                    </Tooltip>
                                )
                            } else if (value.nombre === "modificar") {
                                return (
                                    <Tooltip title="Modificar">
                                        <Button
                                            className="ilist"
                                            type="primary"
                                            shape="circle"
                                            onClick={handleClickModificar.bind(
                                                this,
                                                props.original.id,
                                                props.original.nombre,
                                                props.original.conAlerta)}
                                            disabled={!value.isActivo || !acciones.enableCaptura}
                                        >
                                            <FormOutlined />
                                        </Button>
                                    </Tooltip>
                                )
                            }
                            else if (value.nombre === "eliminar") {
                                return [
                                    <Divider className="dcolor" type="vertical" />,
                                    <Tooltip title="No Adjudicar">
                                        <Button
                                            type="primary"
                                            onClick={handleClickEliminar.bind(this, props.original.id, props.original.nombre, props.original.conAlerta)}
                                            disabled={!value.isActivo || !acciones.enableCaptura}
                                            style = {
                                                {
                                                    transform: "translateY(18.1%)",
                                                    
                                                    backgroundImage: `url(${logoAyuda})`,
                                                    backgroundRepeat: "no-repeat",
                                                    borderStyle: 'none',
                                                    backgroundColor:'transparent',
                                                    boxShadow:'none',

                                                   height:'30px',
                                                   width:'64px',
                                                }
                                            }
                                        >
                                           
                                        </Button>
                                    </Tooltip>
                                ]
                            }
                            else return <span />;
                        })}
                    </div>
                );
            },
            style: {
                color: "blue"
            },
            sortable: false,
            filterable: false
        },
    ];

    function doRequestOptions() {
        if ((user.infoMenu.estadoSelec === null && user.infoMenu.detalleSelec.idEstado === 0) || (user.infoMenu.estadoSelec !== null && user.infoMenu.estadoSelec.idEstado === 0)) {
            message.warning("Favor de seleccionar una entidad en el menú del proceso electoral.",tiempoMensaje);
            return;
        }
        let data = JSON.stringify({
            consultaParametros: {
                idProceso: user.infoMenu.detalleSelec.idProcesoElectoral,
                idDetalleProceso: user.infoMenu.detalleSelec.idDetalleProceso,
                idEstado: user.infoMenu.estadoSelec !== null ? user.infoMenu.estadoSelec.idEstado : user.infoMenu.detalleSelec.idEstado,
                anioProceso: user.infoMenu.detalleSelec.anio,
                tipoProceso: user.infoMenu.detalleSelec.tipoProceso
            }
        })
        getTiposDocumentacionAdjudicacion(data)
            .then(response => {
                if (response.data.entity.code !== 200 && response.data.entity.code !== 403) {
                        message.error("10.- Ocurrió un error. Comunícate al CAU",tiempoMensaje);
                }
                else if (response.data.entity.code === 200) {
                    if (response.data.entity.message !== null && response.data.entity.message !== "") {
                            message.warning(response.data.entity.message,tiempoMensaje);
                    }
                    else {
                        setOptions({
                            data: response.data.entity.select,
                            loadingData: true,
                        });
                    }
                }
                else {
                    localStorage.clear();
                    window.location = "/login"
                }
            })
            .catch(err => {
                if (err.response.status === 403) {
                    localStorage.clear();
                    window.location = "/login"
                    return;
                }
                setOptions({
                    data: [],
                    loadingData: true
                });
                    message.error("Ha ocurrido un error al realizar la petición solicitada.",tiempoMensaje);
            });

            if(props.idTipoDocumentacion !== null && props.idTipoDocumentacion !== undefined) {
                doRequestArticulos(props.idTipoDocumentacion);
            }
    };

    function doRequestArticulos(idTipoDocumentacion) {
        let data = JSON.stringify({
            consultaParametros: {
                idProceso: user.infoMenu.detalleSelec.idProcesoElectoral,
                idDetalleProceso: user.infoMenu.detalleSelec.idDetalleProceso,
                idEstado: user.infoMenu.estadoSelec !== null ? user.infoMenu.estadoSelec.idEstado : user.infoMenu.detalleSelec.idEstado,
                anioProceso: user.infoMenu.detalleSelec.anio,
                tipoProceso: user.infoMenu.detalleSelec.tipoProceso
            },
            idTipoDocumentacion: idTipoDocumentacion
        })
        getArticulosAdjudicacion(data)
            .then(response => {
                if (response.data.entity.code !== 200 && response.data.entity.code !== 403) {
                        message.error(response.data.entity.causa,tiempoMensaje);
                }
                else if (response.data.entity.code === 200) {
                    if (response.data.entity.message !== null && response.data.entity.message !== "") {
                            message.warning(response.data.entity.message,tiempoMensaje);
                    }
                    else {
                        setArticulosData({
                            data: response.data.entity.articulos,
                            notificacionDisable: response.data.entity.notificacionDisable,
                            loadingData: true
                        });
                        setAcciones({
                            enableCaptura: response.data.entity.enableCaptura,
                            enableModificar: response.data.entity.enableModificar
                        });
                    }
                }
                else {
                    //localStorage.clear();
                    window.location = "/login"
                }
            })
            .catch(err => {
                if (err.response.status === 403) {
                    //localStorage.clear();
                    window.location = "/login"
                    return;
                }
                setArticulosData({
                    data: [],
                    notificacionDisable: true,
                    loadingData: false
                });
                    message.error("Ha ocurrido un error al realizar la petición solicitada.",tiempoMensaje);
            });
    }

    function doRequestNotificacion() {
        let data = JSON.stringify({
            parametros: {
                idProceso: user.infoMenu.detalleSelec.idProcesoElectoral,
                idDetalleProceso: user.infoMenu.detalleSelec.idDetalleProceso,
                idEstado: user.infoMenu.estadoSelec !== null ? user.infoMenu.estadoSelec.idEstado : user.infoMenu.detalleSelec.idEstado,
                anioProceso: user.infoMenu.detalleSelec.anio,
                tipoProceso: user.infoMenu.detalleSelec.tipoProceso
            },
            idTipoDocumentacion: selected.data
        })
        enviaNotificacionAdjudicacion(data)
            .then(response => {
                if (response.data.entity.code !== 200 && response.data.entity.code !== 403) {
                        message.error(response.data.entity.causa,tiempoMensaje);
                }
                else if (response.data.entity.code === 200) {
                    if (response.data.entity.message !== null && response.data.entity.message !== "") {
                            message.warning(response.data.entity.message,tiempoMensaje);
                    }
                    else {
                        setArticulosData({
                            data: [],
                            notificacionDisable: true,
                            loadingData: false
                        });
                        message.success("Se ha enviado la notificación al área correspondiente",tiempoMensaje);
                        doRequestArticulos(selected.data);
                    }
                }
                else {
                    localStorage.clear();
                    // console.log("Borro el local storage");
                    window.location = "/login"
                }
            })
            .catch(err => {
                //console.log("Error:=>: doRequestArticulos", err)
                if (err.response.status === 403) {
                    localStorage.clear();
                    window.location = "/login"
                    return;
                }
                    message.error("Ha ocurrido un error a relizar la petición solicitada.", tiempoMensaje);
            });
    }

    function doRequestDesactivaAdjudicacion() {
        let data = JSON.stringify({
            parametros: {
                idProceso: user.infoMenu.detalleSelec.idProcesoElectoral,
                idDetalleProceso: user.infoMenu.detalleSelec.idDetalleProceso,
                idEstado: user.infoMenu.estadoSelec !== null ? user.infoMenu.estadoSelec.idEstado : user.infoMenu.detalleSelec.idEstado,
                anioProceso: user.infoMenu.detalleSelec.anio,
                tipoProceso: user.infoMenu.detalleSelec.tipoProceso
            },
            idTipoDocumentacion: eliminar.idTipoDocumentacion,
            idArticulo: eliminar.idArticulo,
            justificacion: props.form.getFieldValue('justificacion')
        })

        desactivaAdjudicacion(data)
            .then(response => {
                if (response.data.entity.code !== 200 && response.data.entity.code !== 403) {
                        message.error(response.data.entity.causa,tiempoMensaje);
                }
                else if (response.data.entity.code === 200) {
                    if (response.data.entity.message !== null && response.data.entity.message !== "") {
                            message.warning(response.data.entity.message,tiempoMensaje);
                    }
                    else {
                       // console.log("response:=>", response);
                        props.form.resetFields();
                        setArticulosData({
                            data: [],
                            notificacionDisable: true,
                            loadingData: false
                        });
                        doRequestArticulos(selected.data);
                    }
                }
                else {
                    localStorage.clear();
                    // console.log("Borro el local storage");
                    window.location = "/login"
                }
            })
            .catch(err => {
               // console.log("Error:=>: doRequestOptions", err)
                if (err.response.status === 403) {
                    localStorage.clear();
                    window.location = "/login"
                    return;
                }
                props.form.resetFields();
                setOptions({
                    data: [],
                    loadingData: true
                });
                    message.error("Ha ocurrido un error al realizar la petición solicitada.",tiempoMensaje);
            });
    };

    useEffect(() => {
        if (!options.loadingData)
            doRequestOptions();
    }, [options]);

    const handleClose = () => {
        setVisibleAlert({
            activado: false,
            tipoMensaje: "",
            mensaje: ""
        });
    }

    const renderRedirect = () => {
        if (redirect.redirecting) {
            return <Redirect to={{
                pathname: redirect.url,
                state: {
                    idArticulo: redirect.idArticulo,
                    nombreArticulo: redirect.nombreArticulo,
                    idTipoDocumentacion: redirect.idTipoDocumentacion,
                }
            }
            } />
        }
    }

    const handleModalEnviar = () => {
        props.form
            .validateFields()
            .then(values => {
                doRequestDesactivaAdjudicacion();
                setEliminar({
                    visible: false,
                    idArticulo: -1,
                    idTipoDocumentacion: -1,
                    nombre:""
                });
                props.form.resetFields();
            })
            .catch(info => {
                //console.log('Validate Failed:', info);
            });
    }

    const handleModalCancel = () => {
        props.form.resetFields();
        setEliminar({
            visible: false,
            idArticulo: -1,
            idTipoDocumentacion: -1,
            nombre:""
        });
    }

    const handleModalCancelCargaMasiva = () => {
       setArchivoCargaMasiva({
        ...archivoCargaMasiva,
        mostrarModal:false,
       })
    }

    const handleModalEnviarCargaMasiva = () => {
        const formData = new FormData();
        setLoading(true);
        setArchivoCargaMasiva({
            ...archivoCargaMasiva,
            mostrarModal:false,
        })
        formData.append('idProcesoElectoral', user.infoMenu.detalleSelec.idProcesoElectoral);
        formData.append('idDetalleProceso', user.infoMenu.detalleSelec.idDetalleProceso);
        formData.append('idEstado', user.infoMenu.detalleSelec.idEstado);
        formData.append('nombreEstado', user.infoMenu.estadoSelec.nombreEstado);
        formData.append('anio', user.infoMenu.detalleSelec.anio);
        formData.append('tipoProceso', user.infoMenu.detalleSelec.tipoProceso);
        formData.append('idTipoDocumentacion', selected.data);
        formData.append('archivo.archivo', archivoCargaMasiva.file);
        formData.append('usuario', user.user.sub)
        procesaCargaMasivaAdjudicacion(formData)
            .then(response => {
                setLoading(false);
                if (response.data.entity.code !== 200 && response.data.entity.code !== 403) {
                    if (response.data.entity.causa !== null)
                        message.error(response.data.entity.causa, tiempoMensaje);
                    else
                        message.error("10. Ocurrió un error. Comunícate al CAU", tiempoMensaje);
                }
                else if (response.data.entity.code === 200) {
                    setArchivoCargaMasiva({
                        uploading: false,
                        file: "",
                        urlPDF: null,
                    })
                    setFileList([])
                    message.success("La carga de archivos concluyó correctamente.", tiempoMensaje)
                    doRequestArticulos(selected.data);//Se actualiza la lista de articulos de la tabla
                }
                else {
                    localStorage.clear();
                    // console.log("Borro el local storage");
                    window.location = "/login"
                }
            })
            .catch(error => {
                setLoading(false);
                message.error("Ha ocurrido un error al realizar la petición solicitada.", tiempoMensaje);
            })

    }

    const handleModalCancelJustificacion = () => {
        setMuestraJustificacion({
            visible: false,
            nombreArticulo: "",
            justificacion: "",
        });
        props.form.resetFields();
    }

    return (
        <div>
            <Spin tip='Procesando' spinning = {loading} size="large">
            {renderRedirect()}
            <Row>
                {visibleAlert.activado ?
                    (
                        <Mensajes tipoMensaje={visibleAlert.tipoMensaje} mensaje={visibleAlert.mensaje} handleClose={handleClose} />
                    ) : null}
                <br />
                <h1 className="titulo-adjudicacion">Registro de adjudicación</h1>
                <label className="texto-14-adjudicacion">Los datos con ( <label className="rojo-adjudicacion">*</label> ) son requeridos.</label>
                <br />
                <br />
                <br />
                <label className="texto-18-adjudicacion"><label className="rojo-adjudicacion">*</label> Tipo de clasificación de elección</label>
                <br />
                <Col span={12}>
                    <Select
                        style={{width:'100%'}}
                        onSelect={handleSelect.bind(this)}
                        defaultValue={props.idTipoDocumentacion === null || props.idTipoDocumentacion === undefined ? "Seleccionar opción" : props.idTipoDocumentacion}
                        placeholder="Seleccionar opción"
                        id="opcion"
                    >
                        {Object.entries(options.data).map((value, index) => {
                            return <Option id="opcion" key={value[0]}>{value[1]}</Option>;
                        })}
                    </Select>
                </Col>
                {articulosData.loadingData && articulosData.data.length>0 &&
                    (permisos === "DOCSYMAT.ADMIN.OC" || permisos === "DOCSYMAT.CAPTURA.OPLE.JL" 
                        || permisos === "DOCSYMAT.CAU.OC") &&
                <Col span={4}>
                    <Upload {...propsCargaMasiva} accept=".csv">
                        <Tooltip title="Se permiten únicamente archivos en formato CSV">
                        <Button 
                        className="subirCargaMasiva" 
                        style={{minWidth: '150px'}}>
                            <UploadOutlined />Carga Masiva
                        </Button>
                        </Tooltip>
                    </Upload>
                </Col>
                }
            </Row>
            {articulosData.loadingData 
            ?   
            <Row>
                <div className="div-container-table-adjudicacion">
                    <Table
                        columns={columns}
                        data={articulosData.data}
                        defaultPageSize={10}
                        PaginationComponent={Paginacion}
                        filterable={true}
                        noDataText={"Sin datos que mostrar"}
                    />
                </div>
                <div className="div-container-notificar">
                    <Button className="button-notificar"
                        disabled={articulosData.notificacionDisable}
                        onClick={handleNotificar.bind(this)}> Notificar </Button>
                </div>
                <Modal
                    visible={eliminar.visible}
                    title={"No se adjudicara el artículo " + eliminar.nombre}
                    //onOk={handleModalEnvíar}
                    onCancel={handleModalCancel}
                    footer={[
                        <div className="justificacion-footer">
                            <Button key="back" onClick={handleModalCancel} className="boton-modal-cancelar"
                            >
                                Cancelar
                            </Button>
                            <Button key="submit" type="primary"
                                //loading={this.state.modalLoading} 
                                onClick={handleModalEnviar}
                                className="boton-modal-aceptar"
                                disabled={!acciones.enableModificar}
                            >
                                Aceptar
                            </Button>
                        </div>
                    ]}
                >
                    <Form layout="vertical">
                        <Form.Item
                            label="Justificación, a continuación capture el motivo por el cual el artículo seleccionado no será adjudicado. Una vez capturada y enviada se bloqueará, pasando a modo solo de consulta."
                            name="justificacion"
                            hasFeedback
                        >
                            {getFieldDecorator('justificacion', {
                                rules: [
                                    {
                                        required: true,
                                        message: 'Por favor ingresa la justificación!',
                                    }
                                ],
                            })(
                                <TextArea rows={4} autoSize={false} allowClear={true} maxLength={250} />
                            )}
                        </Form.Item>
                    </Form>
                </Modal>
                <Modal
                    visible={muestraJustificacion.visible}
                    title={muestraJustificacion.nombreArticulo}
                    //onOk={handleModalEnvíar}
                    onCancel={handleModalCancelJustificacion}
                    footer={[]}
                >
                    <label className="texto-16-adjudicacion-modal-bold">Justificación</label>
                    <br />
                    <div className="contenidoJustificacion">
                        <label className="texto-16-adjudicacion-modal">{muestraJustificacion.justificacion}</label>
                    </div>
                </Modal>
                <Modal
                    visible={archivoCargaMasiva.mostrarModal}
                    title={ `¿Estás seguro que deseas iniciar la carga del archivo ${archivoCargaMasiva.file.name}?`}
                    //onOk={handleModalEnvíar}
                    onCancel={handleModalCancelCargaMasiva}
                    footer={[
                        <div className="justificacion-footer">
                            <Button key="back" onClick={handleModalCancelCargaMasiva} className="boton-modal-cancelar"
                            >
                                Cancelar
                            </Button>
                            <Button key="submit" type="primary"
                                onClick={handleModalEnviarCargaMasiva}
                                className="boton-modal-aceptar"
                            >
                                Aceptar
                            </Button>
                        </div>
                    ]}
                />
            </Row>
            :
            <div className="div_cargando">
                <br />
                {selected.data !== -1 ? (<Spin size="large" />) : null}
            </div>
            }
            </Spin>
        </div>
    );
}